import type { BulkDeleteTaxCodesMutationOptions } from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysTaxCode } from '../queryKeys';

import { bulkDeleteTaxCodes } from './bulkDeleteTaxCodes';

/**
 * Deletes selected tax codes and refreshes the remaining tax-code views.
 *
 * @param options - Additional mutation options.
 * @returns The bulk tax-code deletion mutation.
 * @see https://app.dev.vestigas.com/redoc#tag/Tax-Codes
 */
export const useMutationBulkDeleteTaxCodes = (
  options?: BulkDeleteTaxCodesMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: bulkDeleteTaxCodes,
    ...options,
    onSuccess(data, variables, onMutateResult, context) {
      for (const taxCodeId of variables.ids) {
        queryClient.removeQueries({
          exact: true,
          queryKey: queryKeysTaxCode.get(taxCodeId),
        });
      }
      void queryClient.invalidateQueries({
        queryKey: queryKeysTaxCode.getAll(),
      });
      void queryClient.invalidateQueries({
        queryKey: queryKeysTaxCode.filterOptions(),
      });

      return options?.onSuccess?.(data, variables, onMutateResult, context);
    },
  });
};
